import __var_0__ from '@stdlib/math/base/assert/is-positive-integer';
import __var_1__ from '@stdlib/math/base/assert/is-finite';
import __var_2__ from '@stdlib/math/base/assert/is-nan';
import __var_3__ from '@stdlib/math/base/special/exp';
import __var_4__ from '@stdlib/constants/math/float64-ln-two';
import __var_5__ from './weights.js';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isPositiveInteger = __var_0__;
var isfinite = __var_1__;
var isnan = __var_2__;
var exp = __var_3__;
var LN2 = __var_4__;
var weights = __var_5__;


// MAIN //

/**
* Evaluates the quantile function of the Wilcoxon signed rank test statistic with `n` observations.
*
* @param {Probability} p - input value
* @param {PositiveInteger} n - number of observations
* @returns {NonNegativeInteger} evaluated quantile function
*
* @example
* var y = quantile( 0.8, 5 );
* // returns 11
*
* @example
* var y = quantile( 0.5, 4 );
* // returns 5
*
* @example
* var y = quantile( 1.1, 5 );
* // returns NaN
*
* @example
* var y = quantile( -0.2, 5 );
* // returns NaN
*
* @example
* var y = quantile( NaN, 5 );
* // returns NaN
*
* @example
* var y = quantile( 0.0, NaN );
* // returns NaN
*/
function quantile( p, n ) {
	var pui;
	var q;
	var r;
	if ( isnan( n ) || !isPositiveInteger( n ) || !isfinite( n ) ) {
		return NaN;
	}
	if ( isnan( p ) || p < 0.0 || p > 1.0 ) {
		return NaN;
	}
	if ( p === 0.0 ) {
		return 0;
	}
	if ( p === 1.0 ) {
		return ( n * ( n + 1 ) ) / 2;
	}
	pui = exp( -n * LN2 );
	r = 0;
	q = -1;
	while ( r < p ) {
		q += 1;
		r += pui * weights( q, n );
	}
	return q;
}


// EXPORTS //
export default quantile;
